<template>
  <div class="login-page">
    <div class="login-content">
      <div class="login-form">
        <div class="form-header">
          <div class="form-logo">
            <img src="/logo.png" alt="Ikhwan Food" />
          </div>
          <h2 class="form-title">Connexion</h2>
          <p class="form-subtitle">
            Connexion automatique en cours...
          </p>
        </div>

        <div class="form-body">
          <div
            v-if="progress && !(localError || error)"
            class="text-center"
          >
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-3 mb-0 text-muted">Veuillez patienter...</p>
          </div>

          <div v-if="localError || error" class="error-message">
            <i class="bi bi-exclamation-triangle"></i>
            <span>{{ localError || error }}</span>
          </div>

          <button
            v-if="localError || error"
            type="button"
            class="btn-login"
            :disabled="progress"
            @click="retry"
          >
            <span class="btn-content">
              <span>Relancer</span>
              <i class="bi bi-arrow-right"></i>
            </span>
          </button>

          <button
            type="button"
            class="btn btn-secondary btn-clear-account"
            @click="$router.push({ name: 'login' })"
            :disabled="progress"
          >
            <i class="bi bi-box-arrow-left"></i>
            <span>Retour Login</span>
          </button>
        </div>
      </div>
    </div>

    <div class="text-center footer-copyright">
      <br />
      © {{ currentYear }} <a href="www.peascom.ma">Peascom</a>,
      Tous les droits sont réservés
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      auth: {},
      progress: false,
      localError: "",
    };
  },
  methods: {
    refreshPage() {
      window.location.reload();
    },
    async attemptLogin() {
      this.localError = "";
      const username = this.$route.query.username;
      const token = this.$route.query.token;

      if (!username || !token) {
        this.localError = "Paramètres de connexion manquants (username/token).";
        return;
      }

      this.progress = true;
      await this.$store
        .dispatch("auth/login", { username, token })
        .catch((e) => {
          let msg = "Echec de connexion via le redirect.";
          if (
            e &&
            e.response &&
            e.response.data &&
            e.response.data.message
          ) {
            msg = e.response.data.message;
          } else if (e && e.message) {
            msg = e.message;
          }
          this.localError = msg;
        });
      this.progress = false;
    },
    retry() {
      return this.attemptLogin();
    },
  },
  computed: {
    ...mapGetters("auth", {
      error: "getError",
    }),
    currentYear() {
      return new Date().getFullYear();
    },
  },
  async created() {
    await this.attemptLogin();
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #ffffff;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-content {
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-form {
  background: #ffffff;
  border-radius: 24px;
  padding: 3rem 2.5rem;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04),
    0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.form-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.form-logo {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  border-radius: 20px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  padding: 1rem;
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.form-title {
  font-size: 2rem;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.02em;
}

.form-subtitle {
  font-size: 1rem;
  color: #64748b;
  margin: 0;
}

.form-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.error-message {
  margin-top: 0;
  padding: 0.875rem 1rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  color: #dc2626;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-login {
  width: 100%;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-weight: 700;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3);
  margin-top: 0.5rem;
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn-clear-account {
  width: 100%;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.9rem;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8fafc;
  color: #64748b;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.footer-copyright {
  margin-top: 2rem;
  color: #64748b;
  font-size: 0.875rem;
}

.footer-copyright a {
  color: #6366f1;
  text-decoration: none;
}

.footer-copyright a:hover {
  text-decoration: underline;
}

@media screen and (max-width: 768px) {
  .login-page {
    padding: 1rem;
  }

  .login-form {
    padding: 2rem 1.5rem;
  }

  .form-title {
    font-size: 1.75rem;
  }

  .form-logo {
    width: 70px;
    height: 70px;
  }
}
</style>
